// src/utils/auth.js

const AUTH_KEY = 'treasureHunt_auth'

/**
 * Store auth token in localStorage
 */
export function setAuthToken(token) {
  localStorage.setItem(AUTH_KEY, token)
}

/**
 * Retrieve auth token from localStorage
 */
export function getAuthToken() {
  return localStorage.getItem(AUTH_KEY)
}

/**
 * Clear auth token from localStorage
 */
export function clearAuthToken() {
  localStorage.removeItem(AUTH_KEY)
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated() {
  return getAuthToken() !== null
}

/**
 * Generate HTTP Basic Auth header from username and password
 * Returns 'Basic base64(username:password)'
 */
export function generateBasicAuth(username, password) {
  const credentials = `${username}:${password}`
  const encoded = btoa(credentials)
  return `Basic ${encoded}`
}

/**
 * Create an Authorization header for KV API calls
 */
export function getAuthHeaders() {
  const token = getAuthToken()
  if (!token) {
    return {}
  }

  return {
    'Authorization': token
  }
}

/**
 * Verify credentials by sending a test request to admin
 * Returns true if credentials are valid
 */
export async function verifyCredentials(username, password) {
  try {
    const authHeader = generateBasicAuth(username, password)
    const response = await fetch('/api/admin/verify', {
      method: 'GET',
      headers: {
        'Authorization': authHeader
      }
    })

    return response.ok
  } catch (error) {
    console.error('Credential verification failed:', error)
    return false
  }
}
